import * as workOrderActions from 'actions/workOrderActions';
import * as statusActions from 'actions/statusActions';

export const middlewareHandler = (store, next, action) => {
    next(action);

    if (action.type === 'ORDER_CLOSE_REQUEST_ADD_FINISHED') {

        const userId = store
            .getState()
            .getIn(['user', 'userId']);

        const payload = {
            closeOrderStart: {
                accountNumber: action.payload.closeOrderRequest.accountNumber,
                orderSystem: action.payload.closeOrderRequest.orderSystem,
                orderId: action.payload.closeOrderRequest.orderId,
                username: action.payload.closeOrderRequest.username
            },
            channels: [userId]
        };

        store.dispatch(workOrderActions.orderCloseStarted(
            payload, action.orderId));

    }

    if (action.type === 'ORDER_CLOSE_FINISHED' || action.type === 'ORDER_CLOSE_FAILED') {

        const userId = store
            .getState()
            .getIn(['user', 'userId']);

        store.dispatch(statusActions.getTechStatusStarted({
            techStatusChange: {
                userId: userId,
                techStatusWorkOrder: {
                    workOrderNumber: action.orderId,
                    arrivalTime: null,
                    serviceType: ""
                },
                "techStatus": "GetStatus"
            },
            channels: [
                userId
            ]
        }, userId));

        store.dispatch(workOrderActions.workOrderGetTechRouteStarted({ userId: userId, isSelf: true }));
        store.dispatch(workOrderActions.clearWorkOrderDetail(action.orderId, 'orderStatus'));

    }
};

export default (store) => (next) => (action) => {
    middlewareHandler(store, next, action);
};



// WEBPACK FOOTER //
// ./src/store/orderCloseMiddleware.js